__turbopack_context__.v({
  "body": "CeZdrW_body",
  "dialog": "CeZdrW_dialog",
  "error": "CeZdrW_error",
  "header": "CeZdrW_header",
  "loading": "CeZdrW_loading",
  "skeletonCard": "CeZdrW_skeletonCard",
  "skeletonCircle": "CeZdrW_skeletonCircle",
  "skeletonPulse": "CeZdrW_skeletonPulse",
  "skeletonRow": "CeZdrW_skeletonRow",
  "skeletonTimeline": "CeZdrW_skeletonTimeline",
  "title": "CeZdrW_title",
});
